export function getName(path) {
    const lastChar = path.slice(-1);
    let name;

    if (lastChar === '/') {
        name = path.slice(0, -1);
    } else {
        name = path;
    }

    const lastIndex = name.lastIndexOf('/');

    if (lastIndex !== -1) {
        name = name.slice(lastIndex + 1);
    }

    return name;
}

export function getFilename(path) {
    let name;
    let ext;
    const filename = getName(path);
    const lastIndex = filename.lastIndexOf('.');

    if (lastIndex > 0) {
        name = filename.slice(0, lastIndex);
        ext = filename.slice(lastIndex + 1);
    } else {
        name = filename;
        ext = '';
    }

    return { name, ext };
}

export function join() {
    // eslint-disable-next-line prefer-rest-params
    let path = arguments[0] || '';

    for (let i = 1; i < arguments.length; i++) {
        // eslint-disable-next-line prefer-rest-params
        const pathPart = arguments[i];

        if (pathPart) {
            const pathEndsWithSlash = path.charAt(path.length - 1) === '/';
            const pathPartStartsWithSlash = pathPart.charAt(0) === '/';

            if (pathEndsWithSlash && pathPartStartsWithSlash) {
                path = path + pathPart.substring(1);
            } else if (!pathEndsWithSlash && !pathPartStartsWithSlash) {
                path = path + '/' + pathPart;
            } else {
                path = path + pathPart;
            }
        }
    }

    return path;
}
